export default {
  namespaced: true,
  state () {
    return {
      activeName: ''
    }
  },
  mutations: { // $store.commit('app-navbar/xxx', payload)
    setActiveName (state, payload) {
      state.activeName = payload
    }
  },
  actions: { // $store.dispatch('app-navbar/xxx')
  },
  getters: { // $store.getters('app-navbar/xxx')
  }
}
